@file:OptIn(ExperimentalComposeUiApi::class)

package article.spring

import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.animateOffsetAsState
import androidx.compose.animation.core.spring
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.scale
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerEventType
import androidx.compose.ui.input.pointer.onPointerEvent
import androidx.compose.ui.layout.LayoutCoordinates
import androidx.compose.ui.layout.boundsInWindow
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import kotlin.math.max
import kotlin.math.pow
import kotlin.math.roundToInt
import kotlin.math.sqrt


@Composable
fun SpringGrid(
    color: Color = Color.White.copy(alpha = .02f),
    content: @Composable () -> Unit,
) {

    Box(
        Modifier.fillMaxSize()
    ) {

        var mousePosition by remember { mutableStateOf(Offset.Zero) }

        Column(
            Modifier
                .fillMaxSize()
                .onPointerEvent(PointerEventType.Move) {
                    mousePosition = it.changes.first().position
                }
        ) {

            for (i in 0..5) {

                Row(Modifier.fillMaxSize().weight(1f)) {

                    for (j in 0..6) {
                        var layoutCoordinates: LayoutCoordinates? by remember {
                            mutableStateOf(null)
                        }

                        var scale: Float by remember {
                            mutableStateOf(1f)
                        }

                        var offset by remember {
                            mutableStateOf(Offset.Zero)
                        }

                        LaunchedEffect(layoutCoordinates, mousePosition) {
                            layoutCoordinates?.let {
                                val center = it.boundsInWindow().center
                                val delta = center - mousePosition
                                val width =
                                    it.parentLayoutCoordinates?.parentCoordinates?.boundsInWindow()?.width
                                        ?: 0f
                                val height =
                                    it.parentLayoutCoordinates?.parentCoordinates?.boundsInWindow()?.height
                                        ?: 0f

                                if (width != 0f && height != 0f) {
                                    val diagonal = sqrt(width.pow(2) + height.pow(2))
                                    val distance = sqrt(delta.x.pow(2) + delta.y.pow(2))

                                    val displacement = 15f

                                    offset = Offset(
                                        displacement * (delta.x / distance),
                                        displacement * (delta.y / distance),
                                    )

                                    scale = 1f / max((distance / diagonal) * 1.7f, .8f)
                                }

                            } ?: 0f
                        }


                        val animatedOffset by animateOffsetAsState(
                            targetValue = offset,
                            animationSpec = spring(
                                stiffness = Spring.StiffnessVeryLow,
                                dampingRatio = Spring.DampingRatioMediumBouncy,
                            )
                        )

                        val animatedScale by animateFloatAsState(
                            targetValue = scale,
                            animationSpec = spring(
                                stiffness = Spring.StiffnessVeryLow,
                                dampingRatio = Spring.DampingRatioLowBouncy,
                            )
                        )

                        Box(
                            Modifier
                                .onGloballyPositioned {
                                    layoutCoordinates = it
                                }
                                .weight(1f)
                                .fillMaxHeight(),
                            contentAlignment = Alignment.Center,
                        ) {
                            Column(
                                Modifier.offset {
                                    IntOffset(
                                        animatedOffset.x.roundToInt(),
                                        animatedOffset.y.roundToInt()
                                    )
                                }
                                    .scale(animatedScale)
                            ) {
                                for (k in 0..1) {
                                    Row {
                                        for (l in 0..1) {
                                            Box(
                                                Modifier.padding(4.dp)
                                                    .size(4.dp)
                                                    .background(
                                                        color,
                                                        CircleShape
                                                    )
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        content()
    }

}